import React from 'react'
import styles from './article.module.css'

export function Article() {
    return (
        <div className={styles.container}>
            <div className={styles.article}>
                <h2 className={styles.title}>
                    Как осуществляется контроль качества продукции SCT Germany?
                </h2>
                <div className={styles.contentWrapper}>
                    <div className={styles.textContent}>
                        <p className={styles.text}>
                            Воздушные фильтры очищают воздух, поступающий в двигатель, от частиц пыли и других загрязнений.
                            Чистый воздух улучшает качество процесса сгорания топлива и обеспечивает оптимальную производительность двигателя.
                            Воздушные фильтры особенно важны в условиях запыленных дорог или в городах с высоким уровнем загрязнения воздуха. Замена
                            воздушного фильтра, в зависимости от условий эксплуатации, рекомендуется каждые 15 000–30 000 км, чтобы избежать дополнительного
                            расхода топлива и поддерживать эффективность работы двигателя.
                        </p>
                    </div>
                    <img src="/images/brake.webp" alt="Фильтр SCT" className={styles.image} />
                </div>
            </div>
        </div>
    )
}
